<template>
  <div>
    <vloader v-if="mx_is" :loading="mx_loading" :value="`- ${$money(proratedDiscountAmount)}`" />
    <slot v-else></slot>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import mx from './mx.vue';
import vloader from './vloader.vue';
import { PRORATED_OF } from '@/store/modules/preview';

export default {
  mixins: [mx],
  components: { vloader },
  computed: {
    ...mapGetters(['getProratedChargeDetails']),
    proratedDiscountAmount() {
      const planCode = this.mx_cartPlan?.plan_code;
      if (!planCode) return '';
      const updatedPlan = this.getProratedChargeDetails.find(
        (x) => x.planCode === planCode && x.of === PRORATED_OF.UPDATED,
      );
      if (!updatedPlan) return 0;
      const discountAmount = updatedPlan.discountAmount ?? 0;
      return discountAmount;
    },
  },
};
</script>
